import * as views from './pages'

angular.module('app.core').config(function ($stateProvider, lazyLoadProvider) {
    $stateProvider
        .state('app.core', {
            abstract: true
        })
        .state('app.core.monitoramento', {
            url: '/externo/monitoramento',
            views: {
                'content@app': lazyLoadProvider.create(views.monitoramento)
            },
            data: {
                title: 'Monitoramento',
                breadcrumbs: ['Externo', 'Monitoramento']
            }
        })
        .state('app.core.callback', {
            url: '/externo/callback',
            views: {
                'content@app': lazyLoadProvider.create(views.callback)
            },
            data: {
                title: 'Callback',
                breadcrumbs: ['Externo', 'Callback']
            }
        })
        .state('app.core.dashboard', {
            url: '/dashboard',
            views: {
                'content@app': lazyLoadProvider.create(views.dashboard)
            },
            data: {
                title: 'Início'
            }
        })
        .state('app.core.funcao', {
            url: '/security/funcao',
            views: {
                'content@app': lazyLoadProvider.create(views.funcao)
            },
            data: {
                title: 'Função',
                breadcrumbs: ['Sistema e Segurança', 'Função'],
                access: { requiredPermissions: ['Feature'] }
            }
        })
        .state('app.core.grupoUsuario', {
            url: '/security/grupousuario',
            views: {
                'content@app': lazyLoadProvider.create(views.grupoUsuario)
            },
            data: {
                title: 'Grupo de Usuário',
                breadcrumbs: ['Sistema e Segurança', 'Grupo de Usuário'],
                access: { requiredPermissions: ['GrupoUsuario'] }
            }
        })
        .state('app.core.parametroBMP', {
            url: '/parametros/parametrobmp',
            views: {
                'content@app': lazyLoadProvider.create(views.parametroBMP)
            },
            data: {
                title: 'Parâmetros BMP',
                breadcrumbs: ['Parâmetros', 'Parâmetros BMP'],
                access: { requiredPermissions: ['ParametroBMP'] }
            }
        })
        .state('app.core.perfil', {
            url: '/security/perfil',
            views: {
                'content@app': lazyLoadProvider.create(views.perfil)
            },
            data: {
                title: 'Perfil',
                breadcrumbs: ['Sistema e Segurança', 'Perfil'],
                access: { requiredPermissions: ['Perfil'] }
            }
        })
        .state('app.core.sequencia', {
            url: '/security/sequencia',
            views: {
                'content@app': lazyLoadProvider.create(views.sequencia)
            },
            data: {
                title: 'Sequência',
                breadcrumbs: ['Sistema e Segurança', 'Sequência'],
                access: { requiredPermissions: ['SysSequencia'] }
            }
        })
        .state('app.core.usuario', {
            url: '/security/usuario',
            views: {
                'content@app': lazyLoadProvider.create(views.usuario)
            },
            data: {
                title: 'Usuário',
                breadcrumbs: ['Sistema e Segurança', 'Usuário'],
                access: { requiredPermissions: ['Usuario'] }
            }
        })
        .state('app.core.usuarioFeature', {
            url: '/security/usuariofeature',
            views: {
                'content@app': lazyLoadProvider.create(views.usuarioFeature)
            },
            data: {
                title: 'Usuário x Função',
                breadcrumbs: ['Sistema e Segurança', 'Usuário x Função'],
                access: { requiredPermissions: ['Usuario'] }
            }
        })
        .state('app.core.userProfile', {
            url: '/security/editarperfil',
            views: {
                'content@app': lazyLoadProvider.create(views.userProfile)
            },
            data: {
                title: 'Editar Perfil',
                breadcrumbs: ['Sistema e Segurança', 'Editar Perfil']
            }
        })
});
